import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import ImageType from '../../../shared/enums/image-type.enums';

@Component({
  selector: 'hdi-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class ImageComponent implements OnChanges, OnDestroy {
  @Input() src: string = '';
  @Input() alt?: string = '';
  @Input() title?: string = '';
  @Input() lazy: boolean = true;
  @Input() width: string = '100%';
  @Input() height: string = 'auto';
  @Input() border: boolean = false;
  @Input() imagePosition: string = 'center';
  @Input() mobileSrc?: string;

  resolvedSrc: string | { src: string; media: string }[] = '';

  constructor(
    private renderer: Renderer2,
    private readonly el: ElementRef
  ) {}

  protected readonly ImageType = ImageType;
  protected readonly Array = Array;

  private readonly PLACEHOLDER_URL = './assets/images/placeholder-image.svg';
  private loadingTimeoutId: ReturnType<typeof setTimeout> | number | undefined;

  onImageLoad(event: Event): void {
    clearTimeout(this.loadingTimeoutId);
    const imgElement = event.target as HTMLImageElement;
    if (imgElement) {
      imgElement.classList.add('loaded');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    clearTimeout(this.loadingTimeoutId);
    if (changes['src']?.currentValue || changes['mobileSrc']?.currentValue) {
      this.resolvedSrc = this.parseSrc(
        changes['src']?.currentValue || changes['mobileSrc']?.currentValue
      );
    }
    /*    this.loadingTimeoutId = setTimeout(() => {
      const imgElement = this.el.nativeElement.querySelector('img');
      this.renderer.addClass(imgElement, 'placeholder-error');
      this.renderer.setAttribute(imgElement, 'src', this.PLACEHOLDER_URL);
      this.resolvedSrc = this.PLACEHOLDER_URL;
    }, 60000);*/
  }

  /**
   * Parses the input `src` to determine if it’s a JSON array or a single string.
   * Handles HTML-encoded input gracefully.
   */
  private parseSrc(src: string): string | { src: string; media: string }[] {
    if (!src) {
      console.warn('ImageComponent: src is empty or undefined.');
      return '';
    }

    try {
      const parsed = JSON.parse(src);
      if (Array.isArray(parsed)) return parsed;
      console.warn('ImageComponent: src is valid JSON but not an array:', src);
    } catch (error) {
      if (typeof src === 'string') {
        return src;
      }
      console.warn('ImageComponent: Failed to parse src as JSON:', error);
    }

    return src;
  }

  onImageError(): void {
    clearTimeout(this.loadingTimeoutId);
    const imgElement = this.el.nativeElement.querySelector('img');
    this.renderer.addClass(imgElement, 'placeholder-error');
    this.renderer.setAttribute(imgElement, 'src', this.PLACEHOLDER_URL);
    this.resolvedSrc = this.PLACEHOLDER_URL;
  }

  ngOnDestroy(): void {
    // Ensure the timer is cleared if the component is destroyed
    clearTimeout(this.loadingTimeoutId);
  }
}
